module.exports = __webpack_public_path__ + "static/media/place-to-relax.168def92.jpg";